import { InjectionToken, inject } from '@angular/core';
import { ChatHubService } from './chat.hub.service';

export const CHAT_SIGNALR_HUB = new InjectionToken<ChatHubService>(
    'CHAT_SIGNALR_HUB',
    {
        providedIn: 'root',
        factory: () => inject(ChatHubService),
    },
);
